import React, { useState,useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Input from '../../../../components/Input/Input';
import { phoneMask, cepMask } from '../../../../shared/masks';
import { fieldsConfig } from '../Helpers/FormFields';

const styles = theme => ({
  button: {
    display: 'inherit',
    margin: `${theme.spacing(2)}px auto`,
    minWidth: '300px',
    minHeight: '50px',
  },
});

const Form = (props) => {
  const {
    values,
    offices,
    departments,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    employeeId,
    setNewItemConfig,
    newItemConfig,
    loading,
    lastDepartments,
    lastOffices
  } = props;

  useEffect(() => {
    updateDepartment();
    updateOffice();
  }, [newItemConfig.value]);

  const [validateCpf, setvalidateCpf] = useState("");
  const [autoValidadeCpf, setautoValidadeCpf] = useState("");

  const updateDepartment = () => {
    if (newItemConfig.type == 'departamento')
      props.setValues({ ...values, departmentId: lastDepartments })
  }

  const updateOffice = () => {
    if (newItemConfig.type == 'cargo')
      props.setValues({ ...values, officeId: lastOffices})
  }

  const validateCPF = (cpf) => {
    var cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '') return setvalidateCpf("");
    // Elimina CPFs invalidos conhecidos	
    if (cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999")
      return setvalidateCpf("");
    // Valida 1o digito	
    var add = 0;
    for (var i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    var rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
      return setvalidateCpf("");
    // Valida 2o digito	
    add = 0;
    for (i = 0; i < 10; i++)
      add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
      return setvalidateCpf("");
    return setvalidateCpf(true);
  }

  const formFields = fieldsConfig(phoneMask, departments, offices, cepMask, setNewItemConfig, validateCpf);
  const addLeadingZero = (e, field) => {
    if (field.config.name === 'pisCode' && e.target.value.length) {
      if (e.target.value.length > 12) {
        e.target.value = e.target.value.slice(0, 12);
      }
      e.target.value = e.target.value.replace(/\D+/g, '');
    }
  };

  (async function () {
    //Dispara o validadro automaticamente para verificar se o cpf já cadastrado e valido ou não.
    if (autoValidadeCpf === "" && values.cpf !== "") {
      setautoValidadeCpf(true);
      if (props.data.cpf !== "" && validateCpf === "") {
        validateCPF(values.cpf);
      }
    }
  })();

  return (
    <form onSubmit={(e) => { e.preventDefault(); }}>
      <Grid item container spacing={2}>
        {formFields.map(field => (
          <>
            <Grid item xs={12} sm={6} key={field.config.name} style={{ display: 'flex', alignItems: 'center' }}>
              <Input
                {...field.config}
                elementType={field.elementType}
                onInput={e => addLeadingZero(e, field)}
                value={values[field.config.name]}
                onChange={field.elementType === 'datePicker' || field.elementType === 'autocomplete' ? setFieldValue : handleChange}
                onBlur={(event) => {
                  if (!employeeId && props.isValid) {
                    props.formValues(values);
                  }
                  if (event.target.name === 'cpf') {
                    validateCPF(event.target.value);
                  }
                  handleBlur(event);
                }}
                fullWidth
                margin="normal"
                error={errors[field.config.name] && touched[field.config.name]}
                helperText={
                  (touched[field.config.name] && errors[field.config.name]) || field.helperText
                }
              />
              {field.config.icon ?
                field.config.icon : null
              }
            </Grid>
          </>
        ))}
      </Grid>

      <div style={{ display: 'flex' }}>
        <Button
          style={{ marginLeft: 'auto', display: !employeeId ? 'none' : '' }}
          onClick={() => props.history.push('/funcionarios')}
        >
          VOLTAR
        </Button>
        {validateCpf == "" ?
          (<Button
            disabled={Button}
            variant="contained"
            color="primary"
            style={{ margin: !employeeId ? '0 0 0 auto' : 'unset' }}
            // disabled={loading && employeeId}
            onClick={(e) => {
              if (!loading) {
                props.handleSubmit(e);
              }
            }}
          >
            {/* <CircularProgress size={20} /> */}
            {loading && employeeId ? <CircularProgress size={20} /> : null}
            PRÓXIMO
          </Button>) :
          <Button
            variant="contained"
            color="primary"
            style={{ margin: !employeeId ? '0 0 0 auto' : 'unset' }}
            disabled={loading && employeeId}
            onClick={(e) => {
              if (!loading) {
                props.handleSubmit(e);
              }
            }}
          >
            {/* <CircularProgress size={20} /> */}
            {loading && employeeId ? <CircularProgress size={20} /> : null}
            PRÓXIMO
          </Button>
        }
      </div>
    </form>
  );
};

const initializeItemForm = item => item || '';
const initializeDateItemForm = item => (item || new Date());

const UpdateEmployeeForm = withFormik({
  enableReinitialize: false,
  mapPropsToValues: props => ({
    name: initializeItemForm(props.data.name),
    phone: initializeItemForm(props.data.phone),
    enrollment: initializeItemForm(props.data.enrollment),
    departmentId: initializeItemForm(props.data.departmentId),
    officeId: initializeItemForm(props.data.officeId),
    cpf: initializeItemForm(props.data.cpf),
    postalCode: initializeItemForm(props.data.postalCode),
    pisCode: initializeItemForm(props.data.pisCode),
    address: initializeItemForm(props.data.address),
    admission: initializeDateItemForm(props.data.admission),
    emailContact: initializeItemForm(props.data.emailContact),
    workplace: props.data.workplace || {
      city: props.data.cityWorkplace && props.data.cityWorkplace.label,
      code: props.data.cityWorkplace && props.data.cityWorkplace.code,
      state: props.data.stateWorkplace && props.data.stateWorkplace.label,
      uf: props.data.stateWorkplace && props.data.stateWorkplace.code,
    },
  }),
  validationSchema: yup.object().shape({
    name: yup.string().required(),
    phone: yup.string().strict(false).trim('Informe um formato válido').required(),
    enrollment: yup.string(),
    departmentId: yup
      .number()
      .integer()
      .required(),
    officeId: yup
      .number()
      .integer()
      .required(),
    cpf: yup.string().strict(false).trim('O CPF deve conter 11 dígitos').required(),
    postalCode: yup.string(),
    pisCode: yup.string().min(10, 'O PIS deve conter 10 dígitos no mínimo'),
    address: yup.string(),
    admission: yup.string().required(),
    emailContact: yup.string().email(),
  }),
  handleSubmit: (values, { props }) => {
    props.formValues(values);
    props.setSubmit(true);
  },
})(Form);

export default withStyles(styles)(withRouter(UpdateEmployeeForm));
